import * as yup from 'yup'

export const yupPhoneNumber = () => yup.string().matches(/^(?![a-zA-Z]+$)[0-9 ,()-]*$/, {
  excludeEmptyString: true,
  message: 'Must be number or symbols: , ( ) - '
})

export const yupStringLength = (min = 0, max = 254) => yup.string().min(min, `Must be contains ${min} characters`).max(max, `Must be at most ${max} characters!`)
